<template>
    <BCard v-if="lesson">
        <BRow>
            <BCol cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="BriefcaseIcon" vsLabel="Course" :vsValue="lesson.course.name" />
                    <ViewData v-if="$existsModule('Academy')" vsIcon="UserIcon" vsLabel="Teacher" :vsValue="lesson.teacher.full_name" />
                    <ViewData vsIcon="DollarSignIcon" vsLabel="Amount" :vsValue="lesson.amount? formatCurrency(lesson.amount) : ''" />
                    <ViewData vsIcon="DollarSignIcon" vsLabel="Cobradas" :vsValue="lesson.already_paid.paid + '/' + lesson.already_paid.total" />
                    <ViewData v-if="$existsModule('Academy')" vsIcon="HomeIcon" vsLabel="Aula" :vsValue="lesson.classroom_id ? lesson.classroom.name : '-'" />
                </table>
            </BCol>
            <BCol cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="CheckCircleIcon" vsLabel="Extra lesson" :vsValue="lesson.is_extra" vsCheckbox />
                    <ViewData vsIcon="CalendarIcon" vsLabel="Start date" :vsValue="formatDate(lesson.start_date)" />
                    <ViewData vsIcon="ClockIcon" vsLabel="Hora comienzo" :vsValue="lesson.start_time" />
                    <ViewData vsIcon="ClockIcon" vsLabel="Hora fin" :vsValue="lesson.end_time" />
                </table>
            </BCol>
            <BCol cols="12" class="mt-2" v-if="lesson.observations">
                <div class="col-12 mb-1 title p-0 font-weight-bold">
                    <FeatherIcon icon="InfoIcon" class="mr-75" />
                    <span>{{ $t('Observations') }}</span>
                </div>
                <div class="col-12 p-0"> {{ lesson.observations }} </div>
            </BCol>
            <BCol cols="12" class="mt-1">
                <div class="d-flex flex-wrap">
                    <BButton :to="{ name: 'lessons-edit', params: { id: lesson.id } }" variant="primary" v-if="ability.can('write', 'lesson')"> {{$t('Edit')}} </BButton>
                    <BButton variant="outline-danger" class="ml-1" @click="deletePopupAxios(lesson.id, `lessons/${lesson.id}`, 'lessons')" v-if="ability.can('delete', 'lesson')"> {{$t('Delete')}} </BButton> 
                </div>
            </BCol>
        </BRow>
    </BCard>
</template>

<script>
import { ref } from '@vue/composition-api';
import { BButton, BCard, BCol, BRow } from 'bootstrap-vue';
import ViewData from '@/components/ViewData.vue';
import ability from '@/libs/acl/ability';
import popups from '@/hooks/popups';
import router from '@/router';
import dateUtils from '@/hooks/dateUtils';
import currency from '@/utils/currency'
import { getLesson } from '@/composables/lessonService'


export default {
    components: { BCard, BRow, BCol, ViewData, BButton },
    setup(){
        const { deletePopupAxios }  = popups()
        const lesson = ref(null)
        const { formatDate } = dateUtils()
        const { formatCurrency } = currency()

        
        const fetchLesson = async function () {
            let response = await getLesson(router.currentRoute.params.id)
            lesson.value = response.data.lesson
        }

        fetchLesson()

        return{
            deletePopupAxios,
            ability,
            lesson, 
            formatDate,
            formatCurrency
        }
    }
}
</script>

<style lang="scss">
    @import 'src/assets/scss/variables/_variables.scss';
    table tr th, .title {
        color: $primary;
    }

    table tr th span, .title {
        text-transform: uppercase;
    }

</style>